import request from '@/utils/request'

// crm 新建商機
export function crmBusinessSave(data) {
  return request({
    url: 'crm/business/save',
    method: 'post',
    data: data
  })
}

// crm 列表
export function crmBusinessIndex(data) {
  return request({
    url: 'crm/business/index',
    method: 'post',
    data: data
  })
}

// 刪除
export function crmBusinessDelete(data) {
  return request({
    url: 'crm/business/delete',
    method: 'post',
    data: data
  })
}

// crm 更新
export function crmBusinessUpdate(data) {
  return request({
    url: 'crm/business/update',
    method: 'post',
    data: data
  })
}

// crm 商機狀態組
export function crmBusinessStatusList(data) {
  return request({
    url: 'crm/business/statusList',
    method: 'post',
    data: data
  })
}

// crm 詳情
export function crmBusinessRead(data) {
  return request({
    url: 'crm/business/read',
    method: 'post',
    data: data
  })
}

/**
 * 商機轉移
 * @param {*} data
 * business_id 	商機陣列
 * owner_user_id 	變更負責人
 * is_remove 1移出，2轉為團隊成員
 * type 許可權 1只讀2讀寫
 */
export function crmBusinessTransfer(data) {
  return request({
    url: 'crm/business/transfer',
    method: 'post',
    data: data
  })
}

/**
 * 商機轉移
 * @param {*} data
 * business_id 	商機
 * status_id 	商機狀態ID
 * content 備註
 */
export function crmBusinessAdvance(data) {
  return request({
    url: 'crm/business/advance',
    method: 'post',
    data: data
  })
}

/**
 * 商機相關產品
 * @param {*} data
 * business_id 	商機ID
 */
export function crmBusinessProduct(data) {
  return request({
    url: 'crm/business/product',
    method: 'post',
    data: data
  })
}

/**
 * 商機導出
 * @param {*} data
 */
export function crmBusinessExcelExport(data) {
  return request({
    url: 'crm/business/excelExport',
    method: 'post',
    data: data,
    responseType: 'blob',
    timeout: 600000
  })
}
